const MAX = 480 * 1024;
const readAsDataURL = (blob) => new Promise((res, rej) => { const r = new FileReader(); r.onload = () => res(String(r.result)); r.onerror = rej; r.readAsDataURL(blob); });
const dataUrlBytes = (u) => Math.floor((u.length - u.indexOf(",") - 1) * 3 / 4);

const loadImg = (src) => new Promise((res, rej) => { const i = new Image(); i.onload = () => res(i); i.onerror = rej; i.src = src; });

// Shrinks any logo image to a data-URL under ~480 KB (resizes + re-encodes; keeps transparency as PNG/WebP).
export async function compressLogo(file) {
  const original = await readAsDataURL(file);
  if (dataUrlBytes(original) <= MAX) return original;
  if (file.type === "image/svg+xml") throw new Error("SVG logo is too large — export it as PNG instead");
  const img = await loadImg(original);
  for (const side of [1024, 800, 600, 400, 300]) {
    const k = Math.min(1, side / Math.max(img.width, img.height));
    const c = document.createElement("canvas");
    c.width = Math.round(img.width * k); c.height = Math.round(img.height * k);
    c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
    for (const [type, q] of [["image/png"], ["image/webp", 0.9], ["image/webp", 0.75]]) {
      const out = c.toDataURL(type, q);
      if (dataUrlBytes(out) <= MAX) return out;
    }
  }
  throw new Error("Could not shrink this logo — try a simpler image");
}
